import React from 'react'
import { Hidden, TextField, Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import MomentUtils from "@date-io/moment";
import moment from 'moment'
import { IconButton } from '@material-ui/core'
import { Modificar } from "../img";

class DateClick extends React.Component {
  constructor(props){
    super(props)
    this.state={
      date: props.date,
      stringDate: moment(props.date).format('LL'),
      // place: (props.location === null || props.location === undefined)? 'Chihuahua' : props.location +', Chih.'
    }
  }

  onChange = (date) => {
    const FormatedDate = date.format('YYYY-MM-DD');
    const StringDate = date.format('LL');
    this.setState({
      date: FormatedDate,
      stringDate: StringDate
    })
    this.props.onChange(FormatedDate)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (
      this.props.date !== nextProps.date ||
      this.state.stringDate !== nextState.stringDate ||
      this.props.disabled !== nextProps.disabled ||
      this.props.preview !== nextProps.preview ||
      this.props.can_edit_date !== nextProps.can_edit_date ||
      this.props.location !== nextProps.location
    );
  }

  componentDidUpdate(prevProps) {
    const date = this.props.date;
    if (date !== prevProps.date) {
      this.setState({
        date: date,
        stringDate: moment(date).format('LL')
       })
    }
  }

  render () {
    const right = 'align-right'
    const { date, stringDate } = this.state
    const { preview, disabled, can_edit_date, location } = this.props

    const place =  (location === null || location === undefined)? 'Chihuahua' : location +', Chih.'

    return (
      <div style={{'zIndex': '1000!important'}}>
        <Hidden only={'xs'}>
          <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="center"
            >
                <Grid item xs={false} sm='auto' md='auto' lg='auto' xl='auto' className='date_line'>
                <TextField
                  variant='standard'
                  value={place + ', ' + stringDate}
                  onChange={this.onChange}
                  className={right + " " + (disabled ? 'disabled' : '') + " " + (preview ? 'preview_text' : '')}
                  fullWidth
                  inputRef={input => {this.input = input}}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: true
                  }}
                />
              </Grid>
              {(preview || disabled || can_edit_date !== 'true')? null : (
              <Grid item xs={false} sm={2} md={2} lg={2} xl={1}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <InlineDatePicker
                    value={date}
                    autoOk
                    onChange={date => this.onChange(date)}
                    format="L"
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <IconButton>
                          <img src={Modificar} className="modificar" alt="icono-modificar"/>
                      </IconButton>)
                    }}
                    className="datepicker"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            )}
          </Grid>
        </Hidden>
        <Hidden only={['lg', 'xl', 'md', 'sm']}>
          <br/>
          <TextField
            fullWidth
            variant='standard'
            type={'text'}
            value={place}
            className={'align-left disabled'}
            disabled={disabled}
            InputProps={{
              disableUnderline: disabled ? true : false,
            }}
          />
          <TextField
            fullWidth
            variant='standard'
            type={'text'}
            value={'a '+ stringDate}
            className={'align-left disabled'}
            disabled={disabled}
            InputProps={{
              disableUnderline: disabled ? true : false,
            }}
          />
        </Hidden>
      </div>
    )
  }
}

DateClick.propTypes = {
  date: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}
export default DateClick



// WEBPACK FOOTER //
// ./src/components/DateClick.js